import React from 'react'

import { Input } from '@chakra-ui/react'
import { Controller } from 'react-hook-form'
import NumberFormat from 'react-number-format'
import FieldWrapper from './FieldWrapper/FieldWrapper'

const PriceInput = ({
  name,
  disabled,
  placeholder = 'Enter',
  label,
  tooltip = label,
  isRequired = true,
  canHighLight = true,
  ...rest
}) => {
  return (
    <Controller
      name={name}
      render={({ field: { onChange, onBlur, value, ref }, fieldState: { error } }) => (
        <FieldWrapper name={name} label={label} tooltip={tooltip} error={error} isRequired={isRequired} {...rest}>
          <Input
            as={NumberFormat}
            bg={(value === undefined || value === '') && isRequired && canHighLight ? 'yellow' : 'white'}
            ref={ref}
            thousandSeparator
            decimalScale={2}
            value={value}
            onValueChange={({ value }) => {
              onChange(parseFloat(value))
            }}
            onBlur={onBlur}
            onFocus={() => {
              const errorElement = document.getElementById(name)
              if (errorElement) {
                errorElement.scrollIntoView({ behavior: `smooth`, block: 'center' })
              }
            }}
            placeholder={placeholder}
            disabled={disabled}
          />
        </FieldWrapper>
      )}
    />
  )
}

export default PriceInput
